/*
  FDP cart upsell — cart page add handling.

  In the side cart the theme's own [data-btn-addtocart] handler adds the item
  and re-renders the drawer, so nothing is needed here. On the cart page that
  handler does a full page reload; this script intercepts the click there
  (capture phase, before the theme's delegated handler) and refreshes the cart
  section in place instead, via the bridge the theme already exposes for the
  "Complete with" drawer. If the bridge is missing, we fall back to a reload.
*/
(function () {
  'use strict';
  if (window.__fdpCartUpsellInit) return;
  window.__fdpCartUpsellInit = true;

  function onCartPage() {
    return document.body.classList.contains('template-cart');
  }

  function setState(button, state) {
    if (!button) return;
    if (state === 'adding') {
      button.disabled = true;
      button.classList.add('is-loading');
      button.dataset.originalText = button.dataset.originalText || button.textContent;
      button.textContent = button.dataset.addingText || 'Adding…';
    } else if (state === 'added') {
      button.classList.remove('is-loading');
      button.classList.add('is-added');
      button.textContent = button.dataset.addedText || 'Added';
    } else {
      button.disabled = false;
      button.classList.remove('is-loading', 'is-added');
      if (button.dataset.originalText) button.textContent = button.dataset.originalText;
    }
  }

  async function addToCart(form) {
    const id = form.querySelector('[name="id"]')?.value;
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    if (!id) throw new Error('Missing variant');
    const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity }] })
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'Could not add item');
    return data;
  }

  async function fetchCart() {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Could not read cart');
    return response.json();
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-fdp-upsell-add]');
    if (!button) return;
    if (!onCartPage()) return;                      // drawer on other pages: theme handles it
    if (button.closest('#halo-cart-sidebar')) return; // drawer opened on cart page: theme reloads, which refreshes both
    if (button.disabled) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const form = button.closest('[data-fdp-upsell-form]');
    const wrapper = button.closest('[data-fdp-cart-upsell]');
    setState(button, 'adding');

    try {
      await addToCart(form);
      setState(button, 'added');
      const cart = await fetchCart();
      const refresh = window.sharedFunctions?.sgCartCompleteWithRefresh;
      if (typeof refresh === 'function') {
        await refresh(cart);
        // The section refresh replaces the cart list (and this card with it).
        // If for any reason the card survived, hide it.
        if (wrapper && document.body.contains(wrapper)) wrapper.hidden = true;
        document.querySelectorAll('[data-cart-count]').forEach((el) => { el.textContent = cart.item_count; });
      } else {
        window.location.reload();
      }
    } catch (error) {
      setState(button, 'reset');
      const message = (error && error.message) || 'Could not add item. Please try again.';
      if (typeof window.showWarning === 'function') window.showWarning(message);
      else alert(message);
    }
  }, true);
})();
